<template>
  <div>
    <div class="mx-5 mt-4">
      <button class="button is-info" @click="onClickYesterday">Yestarday</button>
    </div>
    <DataTable
      :is_createable="false"
      :show_delete="false"
      :show_operations="false"
      :show_header_filter="false"
      title="מועמדים מהיום"
      :fields="fields"
      :response="data" />
  </div>
</template>
<script>
import DataTable from '@/components/DataTable.vue'

export default {
  name: 'TodayApplicants',
  components: {
    DataTable
  },
  data () {
    return {
      fields: [
        {
          name: 'owner',
          component: 'TableCellOwnerWithCheck'
        },
        {
          name: 'full_name',
          component: 'TableCellFullName'
        },
        {
          name: 'applicant_message',
          value: 'applicant_message',
          component: 'Message',
          additional_data: {
            endpoint: '/users/',
            headers: 'admin_headers',
            resource_type: 'Applicant'
          }
        },
        {
          name: 'applicant skills',
          component: 'TableCellApplicantSkill'
        }
      ],
      data: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.getApplicants()
    },
    getApplicants () {
      let request_params = {
        page: this.$route.query.page || 1,
        per: 100,
        applicant_today: 'true'
      }
      this.$network_utils.getApplicants(request_params).then((response) => {
        this.data = Array.isArray(response) ? response : [response]
      })
    },
    onClickYesterday () {
      let request_params = {
        page: this.$route.query.page || 1,
        per: 100,
        applicant_today: '1'
      }
      this.$network_utils.getApplicants(request_params).then((response) => {
        this.data = Array.isArray(response) ? response : [response]
      })
    }
  }
}
</script>
